'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Dependencies: Requires use of Bootstrap collapse

var CollapseX = function () {
	function CollapseX() {
		_classCallCheck(this, CollapseX);
	}

	_createClass(CollapseX, null, [{
		key: 'collapseSiblings',
		value: function collapseSiblings() {
			var buttons = $('[data-toggle="collapse"]');

			if (buttons.length > 0) {
				var _loop = function _loop(i) {
					var button = buttons[i];
					if (button) {
						$(button).on('click', function () {
							var collapse = $(button).parent().parent().find('.collapse');
							collapse.collapse('hide');
						});
					}
				};

				for (var i = 0; i <= buttons.length; i += 1) {
					_loop(i);
				}
			}
		}
	}]);

	return CollapseX;
}();